import SustainabilityService from 'src/modules/sustainability/sustainabilityService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'SUSTAINABILITY_VIEW';

const sustainabilityViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,
  FIND_RESET: `${prefix}_FIND_RESET`,

  reset: () => async (dispatch) => {
    dispatch({
      type: sustainabilityViewActions.FIND_RESET,
    });
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: sustainabilityViewActions.FIND_STARTED,
      });

      const record = await SustainabilityService.find(id);

      dispatch({
        type: sustainabilityViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: sustainabilityViewActions.FIND_ERROR,
      });

      navigateTo('/library/sustainability');
    }
  },
};

export default sustainabilityViewActions;
